var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocalAddress = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none",
  viewBox: "0 0 25 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 0.48,
  d: "M12.824 2.88h-.768c-4.33.264-6.9 5.01-4.96 8.898l4.177 8.378a1.302 1.302 0 0 0 2.334 0l4.178-8.378c1.938-3.888-.636-8.634-4.962-8.898Zm-.384 9.54a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
})));
export { SvgLocalAddress as ReactComponent };
export default __webpack_public_path__ + "assets/images/localAddress.svg";